import React, { useContext } from 'react';
import { QueryContext, QueryProvider } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';
const { string, shape, oneOfType, node, arrayOf } = proptypes;

const SelectedItemDetailsWrapper = ({
  itemId, storeId, dataSource, data, children
}) => {
  const { defaultVariables } = useContext(QueryContext) || {};
  const selectedItemsDefaultVariables = {
    itemId,
    storeId,
    ...(typeof defaultVariables?.current?.isBrandPricingPolicyCompliant === 'boolean' && {
      isBrandPricingPolicyCompliant: defaultVariables.current.isBrandPricingPolicyCompliant
    })
  };

  const mountedFn = () => storeId !== '8119';

  if (storeId === '8119' && !data.itemId) return null;

  return (
    <QueryProvider
      mounted={mountedFn}
      dataSource={dataSource}
      defaultVariables={selectedItemsDefaultVariables}
      cacheKey="selected-item-details"
    >
      {children}
    </QueryProvider>
  );
};

SelectedItemDetailsWrapper.displayName = 'SelectedItemDetailsWrapper';

SelectedItemDetailsWrapper.propTypes = {
  itemId: string,
  storeId: string,
  dataSource: string,
  data: shape({}),
  children: oneOfType([
    arrayOf(node),
    node
  ]).isRequired
};

SelectedItemDetailsWrapper.defaultProps = {
  itemId: '',
  storeId: '',
  dataSource: 'catalog',
  data: {}
};

export { SelectedItemDetailsWrapper };
